import React, { useState } from 'react';
import { Box, DialogContent, DialogTitle } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { useLocationRequest } from '../../hooks/locationRequest';

interface FormData {
  name: string;
}

interface CreateLocationProps {
  setDialogOpen: (open: boolean) => void;
}

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required")
});

const CreateLocation: React.FC<CreateLocationProps> = ({ setDialogOpen }) => {
  const locationRequest = useLocationRequest();
  const { control, handleSubmit, formState: { errors } } = useForm<FormData>({
    resolver: yupResolver(validationSchema)
  });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: FormData) => {
    setLoading(true);
    try {
      const dispatchData = await locationRequest({ method: 'POST', data: data, slug: null, query: null });
      if (dispatchData.meta.requestStatus === 'fulfilled') {
        setDialogOpen(false);
        await locationRequest({ method: 'GET', data: null, slug: null, query: null });
      }
    } catch (error) {
      console.error('Failed to create location:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DialogContent>
      <DialogTitle sx={{ p: 0 }}>Add New Location</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
        <Controller
          name="name"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              autoFocus
              sx={{ width: 300 }}
              {...field}
              label="Name"
              variant="standard"
              error={!!errors.name}
              helperText={errors.name ? errors.name.message : ''}
              fullWidth
              margin="normal"
              disabled={loading}
            />
          )}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mt: 2 }}>
          <Button sx={{ mr: 2 }} onClick={() => setDialogOpen(false)} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="primary" disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </Box>
      </form>
    </DialogContent>
  );
}

export default CreateLocation;
